import React, { useState, useEffect } from "react";
import CryptoJS from "crypto-js";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import MuiCard from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Backdropcircle from "../../../Loading/Backdrop";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import { useAuth } from "../../../Auth/AuthProtecter";
import TransitionAlerts from "../../../Alert/TransitionAlerts.js";
import Skeleton from "../../../Kit/Skeleton/SkeletonCard";

const dataSke = [
  {
    id: 1,
  },
  {
    id: 2,
  },
  {
    id: 3,
  },
];

const LST = process.env.REACT_APP_API_FRRS_LSTOREGE;
const secretKey = process.env.REACT_APP_SECRET_KEY_LOCALSTORAGE;

const Card = styled(MuiCard)(({ theme }) => ({
  border: "1px solid",
  borderColor: (theme.vars || theme).palette.divider,
  width: "100%",
  "&:hover": {
    background:
      "linear-gradient(to bottom right, hsla(210, 100%, 97%, 0.5) 25%, hsla(210, 100%, 90%, 0.3) 100%)",
    borderColor: "primary.light",
    boxShadow: "0px 2px 8px hsla(0, 0%, 0%, 0.1)",
    ...theme.applyStyles("dark", {
      background:
        "linear-gradient(to right bottom, hsla(210, 100%, 12%, 0.2) 25%, hsla(210, 100%, 16%, 0.2) 100%)",
      borderColor: "primary.dark",
      boxShadow: "0px 1px 8px hsla(210, 100%, 25%, 0.5) ",
    }),
  },
  [theme.breakpoints.up("md")]: {
    flexGrow: 1,
    maxWidth: `calc(50% - ${theme.spacing(1)})`,
  },
  variants: [
    {
      props: ({ selected }) => selected,
      style: {
        borderColor: (theme.vars || theme).palette.primary.light,
        ...theme.applyStyles("dark", {
          borderColor: (theme.vars || theme).palette.primary.dark,
        }),
      },
    },
  ],
}));

//
const loct = process.env.REACT_APP_API_AMOUNTCLIENTBYINTERVAL;
const UrlPayment = process.env.REACT_APP_API_APPOINTMENT;

export default function AmountClientByInterval({ ...other }) {
  //
  const auth = useAuth();
  //
  const [Url, setLoginUrl] = React.useState(auth.Domain);
  //
  const { idparty } = auth.infoUserDasboard.person;
  //
  const bytes = CryptoJS.AES.decrypt(sessionStorage.getItem(LST), secretKey);
  const { stat, sucur, fech, hr } = JSON.parse(
    bytes.toString(CryptoJS.enc.Utf8)
  );
  //
  const [paymentType, setPaymentType] = useState("creditCard");
  const [OptLoc, setOptLoc] = useState([]);
  const [AmountClientByInterval, setAmountClientByInterval] = useState(true);
  const [backdropcircle, setBackdropcircle] = useState(false);
  const [messenger, setMessenger] = useState("");
  const [severity, setSeverity] = useState("");
  const [transitionAlerts, setTransitionAlerts] = useState(false);

  const handlePaymentTypeChange = (event) => {
    setPaymentType(event.target.value);
  };

  const handleNext = (amount) => {

    if (Number(amount.amount) > 0) {
      setTransitionAlerts(false);

      const loct = { stat, sucur, fech, hr };
      const state = { ...loct, amount };

      sessionStorage.setItem(
        LST,
        CryptoJS.AES.encrypt(JSON.stringify(state), secretKey).toString()
      );
      setAmountClientByInterval(false);

    } else {
      setMessenger("Sin monto disponible. Por favor, seleccione una fecha posterior.");
      setSeverity("error");
      setTransitionAlerts(true);
    }
  };

  useEffect(() => {
    const fetchResource = async () => {
      const datePost = {
        idparty: Number(idparty),
        date: fech.fecha,
      };
      //
      try {
        //
        //
        const jsonpass = {
          method: "POST",
          body: JSON.stringify(datePost),
        };
        //
        const respass = await fetch(`${Url}${loct}`, jsonpass);
        //
        const res_pass = await respass.json();

        //
        if (respass.status === 200) {
          setOptLoc(res_pass);
        } else {
          setOptLoc([]);
          setMessenger("Intente nuevamente, ocurrio un error.");
          setSeverity("info");
          setTransitionAlerts(true);
        }
        //
      } catch (error) {
        //
        console.log("*****500:", error);
        //
      }
    };
    fetchResource();
  }, []);

  const handlePayment = async () => {
    //
    setBackdropcircle(true);
    setAmountClientByInterval(true);
    setMessenger("");
    setTransitionAlerts(false);
    //

    const datePost = {
      date: hr.idfecha,
      idparty: idparty,
      idschedule: hr.idschedule,
      status: 1,
      idappointmenttype: 1,
    };
    console.log(datePost);
    //
    console.log(`${Url}${UrlPayment}`);
    console.log(datePost);

    try {
      //
      //
      const jsonpass = {
        method: "POST",
        body: JSON.stringify(datePost),
      };
      //
      const respass = await fetch(`${Url}${UrlPayment}`, jsonpass);
      //
      const res_pass = await respass.json();
      console.log(respass.status);
      console.log(res_pass);

      //
      if (respass.status === 200) {
        other.setActiveStep(other.activeStep + 1);
      } else if (respass.status === 400) {
        setBackdropcircle(false);
        setMessenger(res_pass.error);
        setSeverity("error");
        setTransitionAlerts(true);
      } else {
        setBackdropcircle(false);
        setMessenger(res_pass.info);
        setSeverity("info");
        setTransitionAlerts(true);
      }
      //
      setAmountClientByInterval(false);
    } catch (error) {
      //
      console.log(error);
      //
      setBackdropcircle(false);
      setAmountClientByInterval(false);
    }
  };

  return (
    <Stack spacing={{ xs: 3, sm: 6 }}>
      {backdropcircle && <Backdropcircle />}

      <TransitionAlerts
        messenger={messenger}
        severity={severity}
        open={transitionAlerts}
      />

      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h6" gutterBottom>
          <Chip label={`🗺️ ${stat.name}`} />/
          <Chip label={`📍 ${sucur.name}`} />/
          <Chip label={`📅 ${fech.fecha}`} />/
          <Chip label={`🕗 ${hr.hora}`} />
        </Typography>
      </Box>
      <FormControl component="fieldset" fullWidth>
        <Typography variant="h7" gutterBottom>
          Tiene un monto máximo disponible:
        </Typography>
        <RadioGroup
          aria-label="Payment options"
          name="paymentType"
          value={paymentType}
          onChange={handlePaymentTypeChange}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
          }}
        >
          {OptLoc[0]
            ? OptLoc.map((label, i) => (
                <Card key={i}>
                  <CardActionArea
                    onClick={() => handleNext(label)}
                    sx={{
                      ".MuiCardActionArea-focusHighlight": {
                        backgroundColor: "transparent",
                      },
                      "&:focus-visible": {
                        backgroundColor: "action.hover",
                      },
                    }}
                  >
                    <CardContent
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <MonetizationOnIcon
                        fontSize="small"
                        sx={[
                          (theme) => ({
                            color: "grey.400",
                            ...theme.applyStyles("dark", {
                              color: "grey.600",
                            }),
                          }),
                          paymentType === "creditCard" && {
                            color: "primary.main",
                          },
                        ]}
                      />
                      <Typography sx={{ fontWeight: "medium" }}>
                        {label.amount}{" "}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              ))
            : dataSke.map((da, i) => (
                <Card key={da.id}>
                  <Skeleton key={da.id} />
                </Card>
              ))}

          <Button
            sx={{ mt: 5 }}
            disabled={AmountClientByInterval}
            fullWidth
            variant="contained"
            onClick={handlePayment}
          >
            Solicitar cita
          </Button>
        </RadioGroup>
      </FormControl>
    </Stack>
  );
}
